function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { guid } from '@bydesign-ui/utils';
import { getElementScroll } from '@bydesign-ui/hooks';
var hashMatcherRegx = /#([^#]+)$/;
export var AnchorItem = function () {
  function AnchorItem(root, parent, id) {
    _classCallCheck(this, AnchorItem);

    this.parent = null;
    this.offsetTop = 0;
    this.href = '';
    this.root = root;
    this.parent = parent;
    this.id = id || guid();
    this.init();
  }

  _createClass(AnchorItem, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var _options$href = options.href,
          href = _options$href === void 0 ? '' : _options$href;

      if (href !== this.href) {
        this.href = href;
      }
    }
  }, {
    key: "updateOffsetTop",
    value: function updateOffsetTop() {
      var isSilent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var container = this.root.getContainer();
      var href = this.href;

      if (!container) {
        return false;
      }

      if (hashMatcherRegx.exec(href)) {
        var target = document.querySelector(href);

        if (!target) {
          return false;
        }

        var top = 0;

        if (container === document.body || container === document.documentElement) {
          top = target.getBoundingClientRect().top + getElementScroll(container).scrollTop;
        } else {
          top = target.getBoundingClientRect().top - container.getBoundingClientRect().top + getElementScroll(container).scrollTop;
        }

        this.offsetTop = top;

        if (!isSilent) {
          this.root.updateAllItemOffsetTop(this.id);
        }

        return true;
      }

      return false;
    }
  }, {
    key: "getOffsetTop",
    value: function getOffsetTop() {
      return this.offsetTop;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      var level = 1;
      return this.parent ? this.parent.getLevel() + level : level;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.root.unregisterAnchorItem(this);
    }
  }, {
    key: "init",
    value: function init() {
      this.root.registerAnchorItem(this);
    }
  }]);

  return AnchorItem;
}();